import { type ApiCredential } from '@reliance/types/models/ApiCredential';

export function formatCredentialName(credential?: Partial<ApiCredential> | null): string {
  if (!credential) {
    return '';
  }

  const staffUser = credential.staffUser;
  if (staffUser?.firstName || staffUser?.lastName) {
    return [staffUser.firstName, staffUser.lastName].filter(Boolean).join(' ');
  }

  if (credential.facilityUser?.username) {
    return credential.facilityUser.username;
  }

  return credential.userName ?? '';
}
